import { useUnit } from 'effector-react'
import { useCallback } from 'react'
import {
  $disabled,
  $pinLockPopup,
  autoSubmitPinCode,
  changePinCode,
  openPinLockPopup,
} from '../model'

export const usePinLockPlayerBase = () => {
  const pinLockPopup = useUnit($pinLockPopup)
  const disabled = useUnit($disabled)
  const eventAutoSubmitPinCode = useUnit(autoSubmitPinCode)
  const eventChangePinCode = useUnit(changePinCode)
  const openPinLockPopupEvent = useUnit(openPinLockPopup)

  const autoSubmitPinCodeCallback = useCallback(
    (value: string) => {
      eventAutoSubmitPinCode({ value })
    },
    [eventAutoSubmitPinCode]
  )

  const changePinCodeCallback = useCallback(
    (value: string) => {
      eventChangePinCode({ value })
    },
    [eventChangePinCode]
  )

  return {
    pinLockPopup,
    disabled,
    openPinLockPopupEvent,
    autoSubmitPinCodeCallback,
    changePinCodeCallback,
  }
}
